import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import OpenerImage from '../common/opener_image';
import OpenerImagesPropTypes from '../../utils/prop-types/OpenerImagesPropTypes';

const ChannelCard = ({ name, url, rowType, opener_images }) => (
  <div className="channel-card-wrapper">
    <Link to={url} className="channel card">
      <div className="channel-overlay" />
      <div className="channel-content">
        <div className="channel-name">{name}</div>
      </div>
      <OpenerImage
        rowType={rowType}
        opener_images={opener_images}
      />
    </Link>
  </div>
);

ChannelCard.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  rowType: PropTypes.string.isRequired,
  opener_images: OpenerImagesPropTypes.isRequired
};

export default ChannelCard;
